import PERSONAL from './personal'
import EMPLOYMENT from './employment'
import BANK from './bank'
import BANK_RECORDS from './bank-records'
import PAYMENT_PROGRESS from './payment-progress'

export const BASIC_DETAIL_LAYOUT_SETTING = {
  PERSONAL,
  EMPLOYMENT,
  BANK,
  BANK_RECORDS,
  PAYMENT_PROGRESS
}
